import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { createWebApiBridge } from './web/bridge/createWebApiBridge.js';
import ErrorBoundary from './components/ErrorBoundary.jsx';

if (typeof window !== 'undefined' && !window.api) {
  window.api = createWebApiBridge();
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary onError={(err) => console.error('Render crash:', err)}>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
